import { Component } from '@angular/core';
import { IonicPage,ModalController, ViewController } from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { MesasProvider } from '../../providers/mesas/mesas';
import { CajaProvider } from '../../providers/caja/caja';
import { NUBE_AWS } from '../../config/url.servicio';


@IonicPage()
@Component({
  selector: 'page-turnos',
  templateUrl: 'turnos.html',
})
export class TurnosPage {
  turnos = [];
  domicilios = [];
  turnoNuevo = [];
  datosDomicilio = [];
  datosDomicilioTotalDia = [];
  maximopedido = 0;
  minimopedido = 0;
  totalpedido = 0;
  constructor(public modalController: ModalController,
              public servicioMesas: MesasProvider,
              public storage: Storage,
              public servicio: CajaProvider,
              public viewControllers:ViewController) {
                this.buscarTurnos();
                this.buscarDomicilios();
              }

  ngOnInit() {
  }
  buscarTurnos() {
    this.storage.get('companiasId').then((val) => {
      if (val) {
        this.servicio.buscarComandasturnoPorCompaniaAsignados(val)
        .subscribe((items: any)=> {
          let itemsJson = NUBE_AWS ? JSON.parse(items['_body']) : items
          let itemsResponse = NUBE_AWS ? itemsJson.data[0] : items
          items = itemsResponse
          for (let i = 0; i<items.length;i++) {
            if(items[i].domicilio === 'Si') {
              this.domicilios.push({
                turno: items[i].turno,
                numeromesa: items[i].numeromesa,
                codigo: items[i].codigo,
                domicilio: items[i].domicilio,
                primerNombre: items[i].primerNombre,
                numeroTelefono: items[i].numeroTelefono
              });
            } else {
              this.turnos.push({
                turno: items[i].turno,
                numeromesa: items[i].numeromesa,
                codigo: items[i].codigo,
                domicilio: items[i].domicilio,
                primerNombre: items[i].primerNombre,
                numeroTelefono: items[i].numeroTelefono,
                nombreProducto: items[i].nombreProducto
              });
            }
          }
        });
      }
    });
  }
  atras() {
    this.viewControllers.dismiss(this.turnoNuevo);
  }
  buscarDatosId(datos: any, item: any ) {
    let datosId: any;
    if (item !== '') {
      datosId = this.turnos[item];
   } else {
     console.log('sacar mensaje');
     return;
   }
    this.turnoNuevo = datosId;
    this.atras();
  }
  buscarDatosDomiciliosId(datos: any, item: any ) {
    let datosId: any;
    if (item !== '') {
      datosId = this.domicilios[item];
   } else {
     console.log('sacar mensaje');
     return;
   }
    this.turnoNuevo = datosId;
    this.atras();
  }
  buscarDomicilios() {
    this.storage.get('companiasId').then((val)=>{


    this.servicio.buscarDomiciliosPorCompania(val)
    .subscribe((items)=>{
      let itemsJson = NUBE_AWS ? JSON.parse(items['_body']) : items
      let itemsResponse = NUBE_AWS ? itemsJson.data : items
      this.datosDomicilio = itemsResponse[0]

      this.datosDomicilioTotalDia = itemsResponse[1]
      this.maximopedido = itemsResponse[1][0].maximopedido;
      this.minimopedido = itemsResponse[1][0].minimopedido;
      this.totalpedido = itemsResponse[1][0].total;
    }, (error)=>{
      console.log(error)
    })
  })

  }
  ionViewDidLoad() {
    const element = document.getElementsByClassName('modal-wrapper')[0] as HTMLElement;
    element.style.height = '100%';
    element.style.width = '100%';
    element.style.top = '0';
    element.style.left = '0';
    element.style.right = '0';
    element.style.bottom = '0';
  }
}



// WEBPACK FOOTER //
// ./src/pages/turnos/turnos.ts